import { Badge, Card, Col, Container, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { productDetailsLabels } from "../utils/utils";

const ProductDeatilsModalComponent = ({
  show = false,
  rowEdited = null,
  setShow = () => {},
  reduxResetProductForm = () => {}
}) => {
  const handleClose = () => {
    setShow(false);
    reduxResetProductForm();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      onEscapeKeyDown={handleClose}
      backdrop="static"
      keyboard={true}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100">
          <Container>
            <Row className="d-flex justify-content-between align-items-center">
              <Col className="d-flex flex-column">
                <h5 className="font-weight-bold mb-0 text-break">
                  {rowEdited?.name || ""}
                </h5>
                <span className="text-secondary small">
                  {rowEdited?.abbreviation || ""}
                </span>
              </Col>
              <Badge
                pill
                bg={`${rowEdited?.isActive ? "primary" : "secondary"}`}
                className="text-white px-3 py-2"
              >
                {rowEdited?.isActive ? "Activo" : "Inactivo"}
              </Badge>
            </Row>
          </Container>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          {productDetailsLabels(rowEdited).map((product) => (
            <Card className="p-4 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Title className="font-weight-bold mb-4">
                {product.title}
              </Card.Title>
              <Row className="gy-4">
                {product.details.map((detail) => (
                  <Col xs={detail?.space || 6} className="mb-2">
                    <div className="d-flex flex-column">
                      <span className="font-weight-bold text-secondary">
                        {detail.label}
                      </span>
                      <span className="font-weight-medium text-dark">
                        {detail?.value}
                      </span>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card>
          ))}
          <Card className="p-4 mb-4" style={{ borderRadius: "15px" }}>
            <Card.Title className="font-weight-bold mb-4">
              Imagen del producto
            </Card.Title>
            <Row className="gy-4">
              {rowEdited?.image ? (
                <Col xs={12} className="text-center">
                  <img
                    src={rowEdited.image}
                    alt={"Imagen del producto"}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "300px",
                      objectFit: "contain",
                    }}
                  />
                </Col>
              ) : (
                <div
                  className="w-100 d-flex flex-column align-items-center justify-content-center"
                  style={{
                    border: "2px dashed #dee2e6",
                    borderRadius: "12px",
                    minHeight: "250px",
                  }}
                >
                  <i
                    className="fas fa-image"
                    style={{ fontSize: "60px" }}
                  ></i>
                  No hay imagen disponible
                </div>
              )}
            </Row>
          </Card>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    rowEdited: state.productState.rowEdited,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    reduxResetProductForm: () =>
      dispatch({
        type: "RESET_PRODUCT_FORM",
      })
  };
};

export const ProductDetailsModal = connect(mapStateToProps, mapDispatchToProps)(
  ProductDeatilsModalComponent,
);
